import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { useAppSelector, useAppDispatch } from '../reduxhooks';
import React from 'react';
import PageAccountYourAccount from './PageAccountYourAccount';
import PageAccountSignIn from './PageAccountSignIn';
import PageAccountSignUp from './PageAccountSignUp';
import PageAccountSignUpConfirm from './PageAccountSignUpConfirm';
import { UIOverlayViewStatus } from 'common-ts/dist/models/UIOverlayViewStatus';
import { Box, Typography } from '@material-ui/core';
import { SignUpSignInLink } from './OverlayViewAccount';
import { signOutAndReset } from '../redux/AccountRedux';
import { resetCartState } from '../redux/CartRedux';
import { resetAddressList } from '../redux/AddressRedux';
import { resetUserMeasurementList } from '../redux/MeasurementsRedux';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    signInSignUpPage: {
      height: 'auto',
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-evenly',
      alignItems: 'center',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        justifyContent: 'center',
      },
    },
    signUpSignInContainer: {
      paddingTop: '80px',
      paddingBottom: '80px',
      [theme.breakpoints.down('md')]: {
        paddingTop: '20px',
        paddingBottom: '120px',
      },
    }
  }),
);

export default function PageAccount() {
  const dispatch = useAppDispatch();
  const authState = useAppSelector(state => state.account.authState);
  const [isSignIn, setIsSignIn] = React.useState<boolean>(true);
  const [signInPhoneNumber, setSignInPhoneNumber] = React.useState<string>('');
  const classes = useStyles();

  const isInsideIframe = window.self !== window.top;

  if (authState === 'signedin') {
    return (
      <PageAccountYourAccount />
    );
  } else {
    return (
      <div className={classes.signInSignUpPage}>
        {
          isInsideIframe ? 
          <Typography onClick={() => {
            dispatch(signOutAndReset());
            dispatch(resetCartState()); // Uncomment to reset cart on sign out
            dispatch(resetAddressList());
            dispatch(resetUserMeasurementList());
            localStorage.setItem('coupon', '');
            window.parent.postMessage({ type: "RELOAD_ACCOUNT_PARENT" }, "*");
          }}>
            RESET
          </Typography>:
          null
        }
        <Box className={classes.signUpSignInContainer}>
          {
            isSignIn ? 
            <PageAccountSignIn phoneNumber={signInPhoneNumber} 
            changeToSignUpWithPhoneNumber={(phoneNumber: string) => {
              setIsSignIn(false);
            }}/>:
            <PageAccountSignUp changeToSignInWithPhoneNumber={(phoneNumber: string) => {
              setSignInPhoneNumber(phoneNumber);
              setIsSignIn(true);
            }}/>
          }
          <SignUpSignInLink 
          isSignUp={!isSignIn}
          handleClick={(isSignUp) => {
            if (isSignUp) {
              setIsSignIn(true);
            } else {
              setIsSignIn(false);
            }
          }}/>
        </Box>
      </div>
    )
  }
}